import React, { useEffect, useState } from "react";
import { Select, FormInstance } from "antd";
import { IStructureData } from "store/location/location-model";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/index.styled";

const { Option } = Select;

export interface IPropsScreen {
  structuresList: Array<IStructureData>;
  structureActive: number;
  form: FormInstance<any>;
}

interface IDispatchProps {
  locationsStructureActive: (...args: any) => void;
}

export type IPropsStructure = IPropsScreen & IDispatchProps;

const StructureTabPane = ({ structuresList, structureActive, locationsStructureActive, form }: IPropsStructure) => {
  const [geosList, setGeosList] = useState<IStructureData[]>([]);
  const [regionList, setRegionList] = useState<IStructureData[]>([]);

  useEffect(() => {
    if (structureActive && structuresList && structuresList.length > 0) {
      const result = getRegionDataFromChild(structureActive);

      if (result) {
        setGeosList(result.childrens);
        setRegionList(result.parentList);

        form.setFieldsValue({
          region: result.parent.id,
          structureId: structureActive,
        });
      }
    } else if (structuresList && structuresList.length > 0) {
      setRegionList(structuresList);
    }
  }, [structureActive, structuresList]);

  useEffect(() => {
    locationsStructureActive(structureActive);
  }, [locationsStructureActive, structureActive]);

  const handleRegionChange = (value: number) => {
    form.resetFields(["structureId"]);
    const region = structuresList.find((item) => item.id === value);
    setGeosList(region?.childrens || []);
  };

  const handleGeoChange = (value: number) => {
    locationsStructureActive(value);
  };

  const getRegionDataFromChild = (childId: number) => {
    const parent = structuresList.find((p) => p.childrens?.some((c) => c.id === childId));
    const otherRegions = structuresList.filter((item) => item.id !== parent.id);

    return {
      parentList: [parent, ...otherRegions],
      parent,
      childrens: parent.childrens,
    };
  };

  return (
    <S.FirstLine>
      <S.FormItemFieldName
        name="region"
        label={`${useTranslation({ id: "select_your_region" })}*`}
        rules={[
          {
            required: true,
            message: useTranslation({ id: "required_field" }),
          },
        ]}
      >
        <Select placeholder={useTranslation({ id: "select_an_option" })} onChange={handleRegionChange} style={{ width: "100%" }}>
          {regionList.map((item) => (
            <Option key={item.id} value={item.id}>
              {item.description}
            </Option>
          ))}
        </Select>
      </S.FormItemFieldName>
      <S.FormItemFieldName
        name="structureId"
        label={`${useTranslation({ id: "geos" })}*`}
        rules={[
          {
            required: true,
            message: useTranslation({ id: "required_field" }),
          },
        ]}
        disabled={!geosList.length}
      >
        <Select placeholder={useTranslation({ id: "select_an_option" })} onChange={handleGeoChange} style={{ width: "100%" }} disabled={!geosList.length}>
          {geosList.map((geo) => (
            <Option key={geo.id} value={geo.id}>
              {geo.description}
            </Option>
          ))}
        </Select>
      </S.FormItemFieldName>
    </S.FirstLine>
  );
};

export default StructureTabPane;
